import { render, staticRenderFns } from "./SellerBlock.vue?vue&type=template&id=1436c97b&"
import script from "./SellerBlock.vue?vue&type=script&lang=js&"
export * from "./SellerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports